import React from 'react';
import { Cross } from '../Icons/CustomIcons';

const CloseModalButton = ({ onClick, className, ariaLabel = 'Schliessen', children }) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {children || <Cross size={20} />}
  </button>
);

export default CloseModalButton;
